<template>
  <main class="text-center py-5">
    <b-container class="py-5">
      <p class="text-success font-weight-bold">404</p>
      <h1>Page not found</h1>
      <p class="text-muted">The page may have moved or the address may be incorrect.</p>
      <router-link to="/" class="btn btn-success mt-3">Return home</router-link>
    </b-container>
  </main>
</template>

<script>
export default { name: 'NotFound' }
</script>

